import { registerArtisModule } from "@artis/sdk";
import { reactArtisModule } from "@artis/sdk-react";

import { SCRATCHPAD_MODULE } from "@package/scratchpad-utils";

import MarketGridModuleView, { MARKET_GRID_MODULE } from "./MarketGridModule";
import Scratchpad, { init as scratchpadInit } from "./ScratchpadModule";

registerArtisModule(MARKET_GRID_MODULE, reactArtisModule(MarketGridModuleView));
registerArtisModule(SCRATCHPAD_MODULE, reactArtisModule(Scratchpad, scratchpadInit));

export { MARKET_GRID_MODULE };
